import React, { useMemo } from "react";
import { Col, Card } from "react-bootstrap";
import useAuthStore from "stores/authStore";
import useMenuStore from "stores/menuStore";
import { getMenuItems } from "routes/guards";
import menuConfig from "routes/menu-config";
import SidebarMenuItems from "./SidebarMenuItems";

const SidebarMenu = () => {
  const { isLogin, currentUser } = useAuthStore();
  const { useSidebar } = useMenuStore();

  const menuItemsMemo = useMemo(
    () =>
      getMenuItems({
        data: menuConfig.sidebarItems,
        isLogin,
        userRole: currentUser?.role?.permissions || [],
      }),
    [isLogin, currentUser]
  );

  if (!useSidebar === true) {
    return <></>;
  }

  return (
    <Col xs="auto" className="side-menu-container">
      <Card>
        <ul className="sw-25 side-menu mb-0 primary" id="menuSide">
          <SidebarMenuItems menuItems={menuItemsMemo} />
        </ul>
      </Card>
    </Col>
  );
};
export default SidebarMenu;
